<template>
  <v-layout align-center>
    <v-flex xs12 sm10 md8>
      <v-layout wrap>
        <v-flex xs12>
          <div v-if="$apollo.loading">
            <spinner />
          </div>
          <form v-else v-scroll-to-error @submit.prevent="submitForm">
            <div class="screen-title mb-0">
              <span>Create Workshop</span>
            </div>
            <div class="mb-32 title-description">
              You need to provide information about your new workshop. You also need to set an attendance limit or mark it as unlimited. After creating this workshop, your potential attendees will be able to register to it while registering to your event.
            </div>
            <workshop-form
              :vs="$v"
              :initial-values="form"
              :halls="halls"
              :event="event"
              @values="form=$event"
            />
            <main-button
              text="Create"
              depressed
              @click="$emit('submit')"
            />
            <main-button
              text="Cancel"
              flat
              @click.prevent="goBack"
            />
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

import WorkshopForm from './workshop-form.vue'
import MainButton from './../shared/main-button.vue'
import Spinner from './../shared/spinner.vue'
import { createWorkshop } from './../../http'
import { GET_EVENT_SETTINGS } from '../../graphql/event.graphql'
import { GET_EVENT_HALLS } from '../../graphql/halls.graphql'

import { required, requiredIf, minValue } from 'vuelidate/lib/validators'
import { date, minDate, maxDate } from './../../validators'
import { submitGuard } from './../../utils'

export default {
  name: 'new-workshop-container',
  components: {
    WorkshopForm,
    MainButton,
    Spinner,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  validations() {
    const component = this
    const event = this.event

    return {
      form: {
        name: { required },
        from: {
          required,
          date,
          minDate: minDate(() => new Date(event.from)),
          maxDate: maxDate(() => component.form.to || new Date(event.to)),
        },
        to: {
          required,
          date,
          minDate: minDate(() => component.form.from || new Date(event.from)),
          maxDate: maxDate(()=> new Date(event.to)),
        },
        attendanceLimit: {
          required: requiredIf((values) => !values.unlimitedAttendance),
          minValue: minValue(1),
        },
      },
    }
  },
  data: () => ({
    event: {},
    form: { lecturers: [] },
    halls: [],
  }),
  apollo: {
    getEvent: {
      query: GET_EVENT_SETTINGS,
      variables() {
        return {
          id: this.eventId,
        }
      },
      manual: true,
      result({ data: { getEvent: event }, loading }) {
        if (!loading) {
          this.event = event
        }
      },
    },
    getHalls: {
      query: GET_EVENT_HALLS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({loading, data}){
        if(!loading) {
          const { getHalls } = data
          this.halls = getHalls
        }
      },
    },
  },
  methods:{
    async submitForm() {
      await submitGuard(this, async () =>{
        const { lecturers, ...values } = this.form
        const attendanceLimit = values.unlimitedAttendance? 0 : values.attendanceLimit
        const workshopData = {
          ...values,
          lecturerIds: lecturers.map(l => l.id),
          attendanceLimit,
        }
        await createWorkshop(this.eventId, workshopData)
        this.goBack()
      })
    },
  },
}
</script>

<style>
</style>
